var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 30.6758H24.75V14.1758H30.25M30.25 41.6758H24.75V36.1758H30.25M27.5 0.425781C23.8886 0.425781 20.3127 1.13709 16.9762 2.51909C13.6398 3.9011 10.6082 5.92673 8.05456 8.48034C2.89731 13.6376 0 20.6323 0 27.9258C0 35.2192 2.89731 42.214 8.05456 47.3712C10.6082 49.9248 13.6398 51.9505 16.9762 53.3325C20.3127 54.7145 23.8886 55.4258 27.5 55.4258C34.7935 55.4258 41.7882 52.5285 46.9454 47.3712C52.1027 42.214 55 35.2192 55 27.9258C55 24.3144 54.2887 20.7384 52.9067 17.402C51.5247 14.0655 49.499 11.034 46.9454 8.48034C44.3918 5.92673 41.3602 3.9011 38.0238 2.51909C34.6873 1.13709 31.1114 0.425781 27.5 0.425781Z",
    fill: "#A62C4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkInfoRed);
export default __webpack_public_path__ + "static/media/darkInfoRed.2f3a81c668978113ca20dfa9f5072c55.svg";
export { ForwardRef as ReactComponent };